import { c as _c } from "react/compiler-runtime";
import { Slot } from '@radix-ui/react-slot';
import { ChevronRight, MoreHorizontal } from 'lucide-react';
import * as React from 'react';
import { cn } from '@achra/ui/lib/utils';
function Breadcrumb(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <nav aria-label="breadcrumb" data-slot="breadcrumb" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function BreadcrumbList(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ol data-slot="breadcrumb-list" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function BreadcrumbItem(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("inline-flex items-center gap-1.5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <li data-slot="breadcrumb-item" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function BreadcrumbLink(t0) {
  const $ = _c(10);
  let asChild;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      asChild,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = asChild;
    $[2] = className;
    $[3] = props;
  } else {
    asChild = $[1];
    className = $[2];
    props = $[3];
  }
  const Comp = asChild ? Slot : "a";
  let t1;
  if ($[4] !== className) {
    t1 = cn("hover:text-foreground transition-colors", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== Comp || $[7] !== props || $[8] !== t1) {
    t2 = <Comp data-slot="breadcrumb-link" className={t1} {...props} />;
    $[6] = Comp;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function BreadcrumbPage(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-foreground font-normal", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span data-slot="breadcrumb-page" role="link" aria-disabled="true" aria-current="page" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function BreadcrumbSeparator(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("[&>svg]:size-3.5", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = children ?? <ChevronRight />;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <li data-slot="breadcrumb-separator" role="presentation" aria-hidden="true" className={t1} {...props}>{t2}</li>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function BreadcrumbEllipsis(t0) {
  const $ = _c(10);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex size-9 items-center justify-center", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MoreHorizontal className="size-4" />;
    t3 = <span className="sr-only">More</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t1) {
    t4 = <span data-slot="breadcrumb-ellipsis" role="presentation" aria-hidden="true" className={t1} {...props}>{t2}{t3}</span>;
    $[7] = props;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator, BreadcrumbEllipsis };